import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.store.step === $setup.store.config.steps)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: _normalizeClass([$setup.store.config.proceed_classes || 'wpcm-proceed-btn']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.submit()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.store.config.donate_now), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class"]))
      : _createCommentVNode("v-if", true)
  ]))
}